import {Injectable, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {ApiService} from './api.service';
import {AlertsService} from './alerts.service';
import {GET_HEADER_NOTIFICATION} from '../../config';


@Injectable()
export class HeaderService implements OnInit {

  private _globaltimzone = new BehaviorSubject<string>('');
  globaltimzone$ = this._globaltimzone.asObservable();

  private _showHeader = new BehaviorSubject<boolean>(true);
  showHeader$ = this._showHeader.asObservable();

  private _headerNotification = new BehaviorSubject<any>('');
  headerNotification$ = this._headerNotification.asObservable();

  private _logoSubtitle = new BehaviorSubject<string>('');
  logoSubtitle$ = this._logoSubtitle.asObservable();

  private _productType = new BehaviorSubject<string>('');
  productType$ = this._productType.asObservable();

  private _demoMode = new BehaviorSubject<boolean>(false);
  demoMode$ = this._demoMode.asObservable();

  constructor(private apiService: ApiService, private alertsService : AlertsService) {
  }

  ngOnInit() {
    // this.globaltimzone = 'Asia/calcutta';
  }

  showTimzone(value: string) {
    this._globaltimzone.next(value);
  }

  hideHeader() {
    this._showHeader.next(false);
  }

  showHeader() {
    this.headerNotification();
    this._showHeader.next(true);
  }

  setLogoSubTitle(value: string | null | undefined) {
    this.setProductType(value);
    this._logoSubtitle.next(this.getSubTitle(this._productType.getValue() || 'emailapi'));
  }

  setProductType(value: string | null | undefined) {
    const s = value == null ? '' : String(value).trim();
    if (!s || s === 'null' || s === 'undefined') {
      return;
    }
    this._productType.next(s);
  }

  getSubTitle(product_type = 'emailapi') : string{
    if(product_type == 'soip'){
      return "RCS";
    }else if (product_type == 'conv_apps'){
      return "WhatsApp";
    }else if(product_type == 'emailapi'){
      return "Email API";
    }else if(product_type == 'deflector'){
      return "Omnichannel deflector";
    } else if(product_type === 'sms') {
      return "SMS";
    } else if(product_type === 'cpaas_settings') {
      return "CPAAS Settings";
    } else{
      return 'CPaaS'
    }
  }

  headerNotification() {
    this.apiService.get(GET_HEADER_NOTIFICATION)
      .subscribe((result) => {
          if (result['status'] === 'success') {
            this._headerNotification.next(result);
            this.alertsService.showP0Alert(result['data']['p0']);
            // TODO: need to check p1 alerts , not displaying after disabling the error from ApiService
            this.alertsService.showP1Alert(result['data']['p1']);

            if( result['data']['p0'] !== '' || result['data']['p1']!=='' || result['data']['p2']['msg']!== ''  || result['data']['twofa']!=='')
              this.alertsService.alertPresent(true);
            else
              this.alertsService.alertPresent(false);

          }
        },
      );
  }

  setDemoMode(value: boolean) {
    this._demoMode.next(value);
  }
}
